import { collectionEngineV1 } from '../apis.js';
const apcoaAPI = collectionEngineV1('/parking');
export const getParkingLotRemarks = (parkingLotReferenceId) => apcoaAPI('GET', `/parking-lot-remarks/${parkingLotReferenceId}`);
export const createParkingLotRemark = (parkingLotRemark) => apcoaAPI('POST', `/parking-lot-remarks`, {
    body: parkingLotRemark,
});
export const deleteParkingLotRemark = (parkingLotRemarkId) => apcoaAPI('DELETE', `/parking-lot-remarks/${parkingLotRemarkId}`);
export const patchParkingLotRemark = (parkingLotRemarkId, patch) => apcoaAPI('PATCH', `/parking-lot-remarks/${parkingLotRemarkId}`, {
    body: patch,
});
//# sourceMappingURL=parking.js.map